import { render, staticRenderFns } from "./GenericFieldSelect.vue?vue&type=template&id=945655a6&scoped=true&"
import script from "./GenericFieldSelect.vue?vue&type=script&lang=js&"
export * from "./GenericFieldSelect.vue?vue&type=script&lang=js&"
import style0 from "./GenericFieldSelect.vue?vue&type=style&index=0&id=945655a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945655a6",
  null
  
)

export default component.exports